import { ReactComponent as Phishing_erro } from "../assets/imagens/Questoes_SVG/phishing_5erros.svg";
import { ReactComponent as Code} from "../assets/imagens/Questoes_SVG/code.svg";
import { ReactComponent as CodeCalculo } from "../assets/imagens/Questoes_SVG/codeCalculoQuantidade.svg";
import { ReactComponent as Monitor } from "../assets/imagens/Questoes_SVG/monitor.svg";
import { ReactComponent as Phishing } from "../assets/imagens/Questoes_SVG/phishing.svg";
import { ReactComponent as SegurancaDados } from "../assets/imagens/Questoes_SVG/segurancaDados.svg";


export const questoes = [
    {
        phishing_erro : Phishing_erro, //2
        title: "Encontre o que caracteriza esse email como phishing"
    },
    {
        code : Code, //2
        title: "Encontre o erro deste código"
    },
    {
        codeCalculo : CodeCalculo, //3
        title: "Encontre o erro deste código"
    },
    {
        monitor : Monitor, //3
        title: "Encontre o motivo do monitor não estar conectado"
    },
    {
        phishing2: Phishing, //3
        title: "Encontre o que caracteriza esse email como phishing"
    },
    {
        segurancaDados : SegurancaDados, // 2
        title: "Encontre pelo menos um dado sensível à vista"
    },

]